import { keyframes } from '@mui/material/styles';
import { Typography, styled } from '@mui/material';

export const AIStyledText = styled(Typography)(() => ({
  fontSize: '0.75rem',
  letterSpacing: '1px',
  fontWeight: '600',
  color: '#00afcc',
}));

export const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 175, 204, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(236, 42, 171, 0);
  }
`;

export const gradientShiftAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Define gradient styles for consistent AI component styling using brand colors rgb(0, 175, 204) and rgb(236, 42, 171)
export const GRADIENT_PRIMARY =
  'linear-gradient(135deg, rgb(0, 175, 204), rgb(236, 42, 171))';
export const GRADIENT_BACKGROUND =
  'linear-gradient(90deg, rgba(0, 175, 204, 0.06), rgba(236, 42, 171, 0.06))';
export const BANNER_BACKGROUND = 'rgba(0, 175, 204, 0.06)';
export const GRADIENT_TEXT =
  'linear-gradient(90deg, rgb(0, 175, 204), rgb(236, 42, 171))';
export const BORDER_COLOR = '#00afcc';
export const SECONDARY_TEXT_COLOR = '#00afcc';
export const SECONDARY_TEXT_COLOR_HOVER = '#ec2aab';

// Example of different style colors
// export const pulseAnimation = keyframes`
//   0% {
//     box-shadow: 0 0 0 0 rgba(110, 142, 251, 0.4);
//   }
//   70% {
//     box-shadow: 0 0 0 6px rgba(110, 142, 251, 0);
//   }
// `;
// export const GRADIENT_PRIMARY = 'linear-gradient(135deg, #6E8EFB, #4961DC)';
// export const GRADIENT_BACKGROUND = 'linear-gradient(90deg, #F5F0FF, #EFF6FF)';
// export const GRADIENT_TEXT = 'linear-gradient(90deg, #7C3AED, #2563EB)';
// export const BORDER_COLOR = '#7C3AED';
// export const SECONDARY_TEXT_COLOR = '#00afcc';
// export const SECONDARY_TEXT_COLOR_HOVER = '#0061a0';
